<template>
  <div class="menu-wrapper">
    <template v-for="item in routes" >
      <div :key="item.path" v-if="!item.hidden&&item.children">

        <router-link v-if="hasOneShowingChildren(item.children) && !item.children[0].children&&!item.alwaysShow" :to="item.path+'/'+item.children[0].path"
          >
          <el-menu-item :index="item.path+'/'+item.children[0].path" class="menu-item" :class="{'submenu-title-noDropdown':!isNest}">
            <template v-if="item.children[0].meta">
              <m-icon
                v-if="item.children[0].meta.class"
                class="mr-3"
                :size="item.children[0].meta.size"
                :class="item.children[0].meta.class"
              >{{item.children[0].meta.icon}}</m-icon>
              <svg-icon
                class="mr-3"
                v-else
                :icon-class="item.children[0].meta.icon" :special-boi="item.children[0].meta.special"></svg-icon>
            </template>
            <span style="font-size: 16px;" v-if="item.children[0].meta&&item.children[0].meta.title" slot="title">
                {{item.children[0].meta.title.toUpperCase()}}
              <el-badge v-if="item.children[0].meta.title === 'Approval' && approvalCount > 0" :value="approvalCount" class="badge-item">            
              </el-badge>
              <el-badge v-if="item.children[0].meta.title === 'Claims' && claimCount > 0" :value="claimCount" class="badge-item">            
              </el-badge>
            </span>
          </el-menu-item>
        </router-link>

        <el-submenu v-else :index="item.name||item.path" >
          <template slot="title">
            <svg-icon v-if="item.meta&&item.meta.icon" :icon-class="item.meta.icon" :special-boi="item.children[0].meta.special"></svg-icon>
            <span v-if="item.meta&&item.meta.title" slot="title">{{item.meta.title.toUpperCase()}}</span>
          </template>

          <template v-for="child in item.children">
            <div :key="child.path" v-if="!child.hidden">
              <sidebar-item :is-nest="true" class="nest-menu" v-if="child.children&&child.children.length>0" :routes="[child]" :key="child.path"></sidebar-item>

              <router-link v-else :to="item.path+'/'+child.path" :key="child.name">
                <el-menu-item :index="item.path+'/'+child.path">
                  <svg-icon v-if="child.meta&&child.meta.icon" :icon-class="child.meta.icon" :special-boi="item.children[0].meta.special"></svg-icon>
                  <span v-if="child.meta&&child.meta.title" slot="title">{{child.meta.title.toUpperCase()}}</span>
                </el-menu-item>
              </router-link>
            </div>
          </template>
        </el-submenu>

      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'SidebarItem',
  props: {
    routes: {
      type: Array
    },
    isNest: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    hasOneShowingChildren(children) {
      const showingChildren = children.filter(item => {
        return !item.hidden
      })
      if (showingChildren.length === 1) {
        return true
      }
      return false
    }
  },
  computed: {
    approvalCount() {
      return this.$store.getters.unsignedTransactions.length
    },
    claimCount() {
      return this.$store.getters.unclaimed
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .menu-wrapper {
    .menu-item {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-direction: row;
    }
  }
  .badge-item {
    margin-left: 5px;
  }
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue